import { useTranslation } from "react-i18next";
import type { ResponseVitalityCheckinVitalityCheckinQuestionsWithAnswersResponse } from "@src/api/v1/data-contracts";
import ScrollInfoRow from "@src/components/table/ScrollInfoRow";
import { useClientThemeAnswersQuery } from "@src/queries/clients";
import QuestionRow from "./table/QuestionRow";
import { TypographyWithIcon } from "./utils/TypographyWithIcon";
import { withSuspense } from "./wrappers/Suspendable";

interface CheckinAnswersTableProps {
  clientId: string;
  formName: string;
}

const CheckinAnswersTable = ({
  clientId,
  formName,
}: CheckinAnswersTableProps) => {
  const { data } = useClientThemeAnswersQuery(clientId, formName);
  const { t } = useTranslation();

  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <TypographyWithIcon iconLigature="group" outlined>
        {t(`Themes.${formName}.Name`)}
      </TypographyWithIcon>
      {data && (
        <div className="overflow-x-auto">
          <table className="min-w-[650px] w-full" aria-label="simple table">
            <thead>
              <ScrollInfoRow
                date={data.createdAt}
                scoreColumnName="Common.Score"
                score={data.score}
              />
            </thead>
            <tbody>
              {data.questionsWithAnswers?.map(
                (
                  question: ResponseVitalityCheckinVitalityCheckinQuestionsWithAnswersResponse,
                ) => (
                  <QuestionRow
                    key={question.questionKey}
                    questionKey={question.questionKey ?? ""}
                    questionText={question.questionText}
                    answers={question.answers}
                  />
                ),
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default withSuspense(CheckinAnswersTable);
